/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useSelector } from "react-redux";
import { cloneObject } from "./hooks-helpers";
// import { Logger } from "cms/utils/log/logger";

const useGetCurrentOrganization = function () {
    const response = useSelector((state) => state.organization.current);
    if (!response) {
        return undefined;
    }
    const organization = cloneObject(response);
    // Logger.debug('current organization',organization)
    // Logger.flush()
    return organization;
};

export { useGetCurrentOrganization };
